export default "__VITE_ASSET__DNpmOXs3__"